import script from "./LoginC.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginC.vue?vue&type=script&setup=true&lang=js"

import "./LoginC.vue?vue&type=style&index=0&id=fbe61b1a&lang=less"

const __exports__ = script;

export default __exports__